import { Loader2 } from 'lucide-react';

import { cn } from '@/shared/utils/cn';

export interface SpinnerProps {
  className?: string;
  /** Accessible label announced to screen readers. */
  label?: string;
  /** Pixel size of the icon (width = height). Default 16. */
  size?: number;
}

export function Spinner({ className, label = 'Loading', size = 16 }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className={cn('inline-flex items-center', className)}>
      <Loader2 className="animate-spin" aria-hidden="true" width={size} height={size} />
      <span className="sr-only">{label}</span>
    </span>
  );
}
